import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { format } from "date-fns/format";
import { parseISO } from "date-fns/parseISO";

import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { asTitle } from "utils/Utils";

import { ReportFieldRights, ReportRight } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { ReportInfo } from "trajectory/TrajectoryService";

export type ReportOverviewRowProps = {
	report: ReportInfo;
	rights: ReportFieldRights;
	selected: boolean;

	onSelect: (id: number, selected: boolean) => void;
};

export default function ReportOverviewRow(
	props: Readonly<ReportOverviewRowProps>
): JSX.Element {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleSelect = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>): void => {
			props.onSelect(props.report.id, event.target.checked);
		},
		[props.report.id]
	);

	const handleOpen = useCallback((): void => {
		navigate(`${location.pathname}/${props.report.id}`);
	}, [props.report.id]);

	return (
		<TableRow
			id={"report-" + props.report.id}
			key={"report-" + props.report.id}>
			<TableCell padding="checkbox">
				{props.rights[""][ReportRight.ADMIN] && (
					<Checkbox
						id={"select-" + props.report.id}
						edge="start"
						checked={props.selected}
						onChange={handleSelect}
					/>
				)}
			</TableCell>
			<TableCell>
				<Link
					style={{
						cursor: "pointer"
					}}
					onClick={handleOpen}
					underline="hover">
					{`${asTitle(t("report"))} ${format(
						parseISO(props.report.created),
						"dd/MM/yyyy HH:mm:ss"
					)}`}
				</Link>
			</TableCell>
			<TableCell>{props.report.name}</TableCell>
		</TableRow>
	);
}
